import { Card, Stack, Typography, useTheme } from '@mui/material';

import { DynamicIcon } from '@frontend-libs/atomic';

import { PortalTheme } from '../../theme';

export interface VoucherListItemProps {
  claimed: boolean;
  stampNumber: number;
}

export const Stamp = (props: VoucherListItemProps) => {
  const theme = useTheme<PortalTheme>();

  return (
    <Card
      sx={{
        width: '52px',
        height: '40px',
        borderRadius: `${theme.shape.borderRadius}px`,
        border: `1px solid ${theme.palette.divider}`,
        padding: 0,
        margin: 0,
        backgroundColor: props.claimed
          ? theme.palette.primary.main
          : 'transparent',
        position: 'relative',
      }}
    >
      <Stack
        direction="row"
        spacing={0}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        {props.claimed ? (
          <DynamicIcon
            width={24}
            height={24}
            iconId="tick"
            strokeColor={theme.palette.primary.contrastText}
            strokeWidth={2}
          />
        ) : (
          <Typography variant="subtitle1">{props.stampNumber}</Typography>
        )}
      </Stack>
    </Card>
  );
};
